import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { type UpdateClaimCampaignBody, updateClaimCampaign } from '~/services/LuxLoyalty';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

interface UpdateClaimCampaignParams {
  campaignId: string;
  body: UpdateClaimCampaignBody;
}

/**
 * Updates an existing claim campaign and invalidates related caches.
 */
export function useUpdateClaimCampaign() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ campaignId, body }: UpdateClaimCampaignParams) => {
      return await updateClaimCampaign(campaignId, body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: claimCampaignQueryKeys.all });
      enqueueSnackbar('Claim campaign updated successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error updating claim campaign: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
